export default __webpack_public_path__ + "static/zoolander-landscape-ee3a95f353a7f6ac2e0399469c612fc0.jpg";